// extracted by mini-css-extract-plugin
export default {"navbar":"navbar___ydeg6"};